// Only inboxes already granted by the inbox API may appear in the sidebar.
export function projectInboxGroups(inboxes, groups, showEmpty = false) {
  const assigned = new Set();
  const result = groups.map(group => {
    const members = new Set(group.inbox_ids.map(Number));
    const items = inboxes.filter(inbox => {
      const id = Number(inbox.id);
      if (!members.has(id) || assigned.has(id)) return false;
      assigned.add(id);
      return true;
    });
    return { ...group, inboxes: items };
  }).filter(group => showEmpty || group.inboxes.length);
  const ungrouped = inboxes.filter(inbox => !assigned.has(Number(inbox.id)));
  if (ungrouped.length || showEmpty) {
    result.push({ id: 'ungrouped', name: '未分组', inboxes: ungrouped });
  }
  return result;
}
